import { STATIC_CONF } from './environment.static';

export const environment = {
  name: 'orion-adfs',
  production: true,
  ...STATIC_CONF,
};
